import { atom } from 'jotai'

export const selectedFlavorAtom = atom<string>('flavor_0')
export const selectedPurchaseOptionAtom = atom<string>('subscribe')
